export default {
    GET_MEMBERS(state, data) {
      state.members = data.data;
    }
}